import React, { useContext, useState } from 'react';
import { I18nContext } from '../../../providers/i18n';
import './styles.scss';

const KantonSelection = ({ regions, onRegionChosen, hasResults, districtLabel }) => {
  const itemIds = Object.keys(regions);
  const [chosenRegion, chooseRegion] = useState(null);
  const { t } = useContext(I18nContext);

  const onSelect = ({ target: { value } }) => {
    chooseRegion(value);
  };

  const submitRegion = () => {
    onRegionChosen(chosenRegion);
  };

  return (
    <div className="kanton-selection">
      <h3 className="kanton-selection-title">{t('elections.regionSelection.titleStart') + districtLabel + t('elections.regionSelection.titleEnd')}</h3>
      <select required className="kanton-select" defaultValue="" onInput={onSelect}>
        <option hidden value="" disabled>
          {districtLabel}
        </option>
        {itemIds.map(regionId => (
          <option key={regionId} value={regionId}>
            {regions[regionId]}
          </option>
        ))}
      </select>
      <button className="kanton-submit-button" disabled={!chosenRegion} onClick={submitRegion}>
        {t('elections.regionSelection.seeResultsButton')}
      </button>
    </div>
  );
};

export default KantonSelection;
